export default __webpack_public_path__ + "media/images/paylogos/gray/mastercard@2x-29404dc21ac414c64a036fa497882511.png";